<button mat-raised-button (click)="onButtonClick($event)" class="{{cssClass}}" [disabled]="disabled" [type]="type">
  <strong>
    <ng-content></ng-content>
  </strong>
</button>
